import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalContainer from '../container';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import { LinearProgress } from 'material-ui/Progress';

const UpsellModal = props => {
  const {showModal, hideModal} = props;
  const title = "Processing your order . . . ";

  return (
    <ModalContainer {...props} disableClose={true} title={title}>
      <Grid container>
        <Grid item sm={12}>
          <LinearProgress color="primary" size={50}/>
        </Grid>
      </Grid>
    </ModalContainer>
  )
}

export default UpsellModal;


// WEBPACK FOOTER //
// ./routes/Modal/Spinner/index.jsx